import { render } from "./master.vue?vue&type=template&id=5b38e28a&scoped=true"
import script from "./master.vue?vue&type=script&lang=js"
export * from "./master.vue?vue&type=script&lang=js"

import "./master.vue?vue&type=style&index=0&id=5b38e28a&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b38e28a"]])

export default __exports__